import displayStyles from '../../styles/Display.module.css';

/**
 * How a marker is drawn as a display figure (plan map-display): its stalk
 * always drawn, its head at half its height, and the display's classes.
 * The shared marker applies what it is given; absent, it is the classic marker.
 */
export interface FigureStyle {
  look: 'display';
  className: string;
  stalkClassName: string;
}

export const DISPLAY_FIGURE: FigureStyle = {
  look: 'display',
  className: displayStyles.figure,
  stalkClassName: displayStyles.figureStalk,
};
